import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

// axios、ajax封装
import * as http from '@/api/request'
// 统一接口管理
import api from '@/api/api.js'

import router, { constantRoutes, resetRouter } from '@/router'
import product from "@/views/product/product.vue"//产品服务主页面
/*
 * @description: 主要用作socket接收事件的中转存储
 */
export default new Vuex.Store({
	state: {
		socketMsg: {}, // 消息中心
		socketWarn: {}, // 告警信息
		socketTime: {}, // 行程设备时长自动上报
		socketStatus: {}, // 执行设备实时状态
		socketOnline: {}, // 在离线
		deviceMessaageOne: {},// 设备状态改变类型新版
		SocketOpen: {},
		addRoutes: false,//是否获取过菜单
		autoRoutes:[],//动态获取的菜单
	},
	mutations: {
		setSocketMsg(state, data) {
			state.socketMsg = data
		},
		setSocketWarn(state, data) {
			state.socketWarn = data
		},
		setSocketTime(state, data) {
			state.socketTime = data
		},
		setSocketStatus(state, data) {
			state.socketStatus = data
		},
		setSocketOnline(state, data) {
			state.socketOnline = data
		},
		setdeviceMessaageOne(state, data) {
			state.deviceMessaageOne = data
		},
		setSocketOpen(state, data) {
			state.SocketOpen = data
		},
		SET_ROUTES: (state, routes) => {
			// if (!routes.length && state.addRoutes.length) {
			// 	resetRouter()
			// }
			state.addRoutes = routes
			// state.routes = constantRoutes.concat(routes);

		},
		SET_autoRoutes:(state, data)=> {
			state.autoRoutes = data
		}
	},
	actions: {
		// 生成路由
		GenerateRoutes({ commit }) {
			return new Promise((resolve) => {
				let params = {
					type: "1",
					deviceType:""
				}
				http.getAction(api.productNameModelList, params).then((res) => {
					if (res.data) {
						let list = []
						res.data.forEach((item) => {
							list.push({
								path: item.productNameCode,
								component: product,
								meta:{title: item.productNameName}
							})
						})
						commit('SET_ROUTES', true)
						resolve(list)
					}
				})
			})
		}
	},
})
